
import { Component, Vue, Prop } from "vue-property-decorator";
import ErrorNotification from "./ErrorNotification.vue";
import { namespace } from "vuex-class";
const schedule = namespace("schedule");
import moment from 'moment';
import TrainingVideos from "./TrainingVideos.vue";
const profile = namespace("profile");

 @Component({
    components: {
            ErrorNotification, TrainingVideos
        },
    })
export default class AssignmentDetail extends Vue {
    @schedule.State 
    public assignmentDetail!: any;

    @profile.State
    public profileData!: any;

    isLoaded: boolean = false;
    showErrorMsg: boolean = false;
     errorMsg: string = '';
     errorType: string = 'error';
    @Prop() currentEvent: any;
    @Prop() enableField: any;
    @Prop() showTrainingVideo!: boolean;

    async mounted() {
        this.getEventDetail();
    }

    getEventDetail() {
        var payload = { 
            username: this.profileData.username, 
            id: this.currentEvent.id
        };  

        this.$store
        .dispatch("schedule/getAssignmentDetail", payload)
        .then(() => {
            this.isLoaded = true;
        });
    }
  get getDept() {
            return this.assignmentDetail.departmentCode + " (" + this.assignmentDetail.departmentName + ")";
        }
  formatDate(date: Date): string {
    return moment(date).format("dddd, MMM DD YYYY");
  }
}
